// 全体の親
import Index from "@/pages/supportSite/Index"

// トップページ
import TopPage from "@/pages/supportSite/TopPage";

// お客様情報表示
import ShowCustomerInfo from "@/pages/supportSite/ShowCustomerInfo";

// お客様情報変更申込
import ChangeCustomerInfo from "@/pages/supportSite/ChangeCustomerInfo";

// メールアドレス変更
import ChangeMail from "@/pages/supportSite/ChangeMail";                   // 変更
import ChangeMailReception from "@/pages/supportSite/ChangeMailReception"; // 変更受付
import ChangeMailDone from "@/pages/supportSite/ChangeMailDone";           // 変更完了

// ご契約種別・お支払い方法変更
import ChangePayment from "@/pages/supportSite/ChangePayment";

// パスワード変更
import ChangePassword from "@/pages/supportSite/ChangePassword";

// アカウント管理
import AccountList from "@/pages/supportSite/AccountList";                     // 一覧
import AddAccount from "@/pages/supportSite/AddAccount";                       // 追加
import ExecuteAddAccount from "@/pages/supportSite/ExecuteAddAccount";         // 追加実行
import DoneExecuteAddAccount from "@/pages/supportSite/DoneExecuteAddAccount"; // 追加完了

// ご契約環境選択
import ContractSelect from "@/pages/supportSite/ContractSelect";

// ユーザー数変更
import NeoNumberChange from "@/pages/supportSite/NeoNumberChange";

// 申し込み履歴
import OrderHistory from "@/pages/supportSite/OrderHistory";

// 見積書一覧
import QuotationList from "@/pages/supportSite/QuotationList";

// 受付窓口表示
import ContactInfo from "../pages/supportSite/ContactInfo.vue";

// システムエラー
import SystemError from "@/pages/SystemError";

// アプリケーションエラー
import ApplicationError from "@/pages/ApplicationError";

export default [
  {
    path: "/support_site",
    component: Index,
    children: [
      // トップページ
      {
        // トップページ
        path: "top_page",
        name: "TopPage",
        component: TopPage,
        meta: {
          currentPage: "TopPage"
        },
        props: true
      },
      // お客様情報
      {
        // お客様情報確認
        path: "show_customer_info",
        name: "ShowCustomerInfo",
        component: ShowCustomerInfo,
        meta: {
          currentPage: "CustomerInfo"
        },
        props: true
      },
      {
        // お客様情報変更
        path: "change_customer_info",
        name: "ChangeCustomerInfo",
        component: ChangeCustomerInfo,
        meta: {
          currentPage: "CustomerInfo"
        },
        props: true
      },
      {
        // E-mail変更
        path: "change_mail",
        name: "ChangeMail",
        component: ChangeMail,
        meta: {
          currentPage: "CustomerInfo"
        },
        props: true
      },
      {
        // E-mail変更受付
        path: "change_mail_reception",
        name: "ChangeMailReception",
        component: ChangeMailReception,
        meta: {
          currentPage: "CustomerInfo"
        },
        props: true
      },
      {
        // ご契約・お支払い方法変更
        path: "change_payment",
        name: "ChangePayment",
        component: ChangePayment,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // パスワード変更
        path: "change_password",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // アカウント一覧
        path: "account/list",
        name: "AccountList",
        component: AccountList,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // アカウント追加
        path: "account/add",
        name: "AddAccount",
        component: AddAccount,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // ご契約環境選択
        path: "contract_select",
        name: "ContractSelect",
        component: ContractSelect,
        props: true
      },
      // ユーザー数変更
      {
        path: "neo_number_change",
        name: "NeoNumberChange",
        component: NeoNumberChange,
        meta: {
          currentPage: "NeoInfo"
        },
        props: true
      },
      // 申し込み履歴
      {
        path: "order_history",
        name: "OrderHistory",
        component: OrderHistory,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // 見積書一覧
        path: "quotation_list",
        name: "QuotationList",
        component: QuotationList,
        props: true
      },
      {
        // 受付窓口表示
        path: "contact_info",
        name: "ContactInfo",
        component: ContactInfo,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // システムエラー
        path: "system_error",
        name: "SupportSystemError",
        component: SystemError,
        meta: {
          currentPage: ""
        },
        props: true
      },
      {
        // システムエラー
        path: "application_error",
        name: "SupportApplicationError",
        component: ApplicationError,
        meta: {
          currentPage: ""
        },
        props: true
      },
    ]
  },
  {
    // E-mail変更完了
    path: "/change_mail_done",
    name: "ChangeMailDone",
    component: ChangeMailDone,
    meta: {
      title: 'E-mail変更 - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
  {
    // アカウント追加実行
    path: "/account/add/execute",
    name: "ExecuteAddAccount",
    component: ExecuteAddAccount,
    meta: {
      currentPage: "",
      title: 'アカウント追加お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
  {
    // アカウント追加完了
    path: "/account/add/done_execute",
    name: "DoneExecuteAddAccount",
    component: DoneExecuteAddAccount,
    meta: {
      currentPage: "",
      title: 'アカウント追加お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  }
]
